
const rootEl = document.getElementById('js-persistent-cta');

if (rootEl) {
  [
    'js-persistent-cta-trigger',
    'js-persistent-cta-close-button',
  ]
    .map(id => document.getElementById(id))
    .filter(el => el)
    .forEach((el) => {
      el.addEventListener('click', () => {
        rootEl.classList.toggle('persistent-cta--open');
      });
    });
}
